import { render, staticRenderFns } from "./RiskEvaluate.vue?vue&type=template&id=195c9c62&scoped=true"
import script from "./RiskEvaluate.vue?vue&type=script&lang=js"
export * from "./RiskEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c9c62",
  null
  
)

export default component.exports